import { useState } from 'react';
import { useRole } from './useRole';
import {
  DIVISION_CONTROLLER,
  SALES_SUPERVISOR,
  TEAM_MEMBER,
} from '../constants/roles';

export const useForm = (initialValues = {}, initialValidationRules = {}) => {
  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState({});
  const [validationRules, setValidationRules] = useState(initialValidationRules);
  const { data: rolesData } = useRole();

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "role" && rolesData) {
      const selectedRole = rolesData.find(role => role.id === value)?.name || '';
      const updatedRules = { ...validationRules };

      if (selectedRole === DIVISION_CONTROLLER) {
        updatedRules.division = { required: true };
        updatedRules.team = { required: false };
      } else if (selectedRole === SALES_SUPERVISOR || selectedRole === TEAM_MEMBER) {
        updatedRules.division = { required: true };
        updatedRules.team = { required: true };
      } else {
        updatedRules.division = { required: false };
        updatedRules.team = { required: false };
      }

      setValidationRules(updatedRules);
    }

    setValues(prev => ({ ...prev, [name]: value }));
    validateField(name, value);
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    validateField(name, value);
  };


  

  const setFieldValue = (name, value) => {
    setValues(prev => ({ ...prev, [name]: value }));
    validateField(name, value);
  };

  const validateField = (name, value) => {
    const rules = validationRules[name];

    if (!rules) return;
  
    let error = '';
    
    if (rules.required && !value) {
      error = 'This field is required';
    } else if (rules.minLength && value.length < rules.minLength.value) {
      error = `Minimum length is ${rules.minLength.value} characters`;
    } else if (rules.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      error = 'Invalid email address';
    }
  
    setErrors(prev => ({ ...prev, [name]: error }));
    return !error; // Return true if no error
  };

  const validateAll = () => {
    const newErrors = {};
    let isValid = true;
  
    Object.keys(validationRules).forEach((name) => {
      const value = values[name];
      const rules = validationRules[name];
      let error = '';
  
      if (rules.required && !value) {
        error = 'This field is required';
      }
      
      if (!error && rules.minLength && value.length < rules.minLength.value) {
        error = `Minimum length is ${rules.minLength.value} characters`;
      }
      
      if (!error && rules.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        error = 'Invalid email address';
      }
  
      if (error) {
        newErrors[name] = error;
        isValid = false;
      } else {
        if (errors[name]) {
          delete errors[name];
        }
      }
    });
  
    setErrors(newErrors);
    return isValid;
  };

  const resetForm = () => {
    setValues(initialValues);
    setErrors({});
    setValidationRules(initialValidationRules); // Reset the rules as well
  };

  return {
    values,
    errors,
    handleChange,
    handleBlur,
    setFieldValue,
    validateAll,
    resetForm
  };
};